"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return [["hem", "hem de"], ["ne", "ne de"], ["ya", "ya da"], ["gerek", "gerekse de"]];
};